import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { AppFormScene } from 'shared-ui/lib/customs/react/app-form-scene/AppFormScene';
import { useParams } from 'shared-ui/lib/utils/use-params';
import { routesConfig } from '../../config/routes.config';
import { TransferConsumerFormBody, transferConsumerForm } from '../../forms/transfer-consumer.form';
import {
  usePreviewTransferConsumerLazyQuery,
  useTransferVehicleToConsumerMutation,
} from '../../generated/graphql';
import { useGQLContext } from '../../hooks/use-gql-context';

export const VehicleTransferConsumerScene = (): JSX.Element => {
  const { t } = useTranslation('VehicleTransferConsumerScene');
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const context = useGQLContext();

  const [updateVehicle, { loading }] = useTransferVehicleToConsumerMutation({
    onCompleted: (data) => {
      if (data.transferVehicleToConsumer) {
        toast.success(t('Common:saved'));
        navigate(routesConfig.VEHICLE.INDEX);
      }
    },
    context,
  });

  const [confirmTransfer] = usePreviewTransferConsumerLazyQuery({
    onCompleted: (data) => {
      if (data.aUser && data.aVehicle) {
        if (
          confirm(
            `Oletko varma että haluat siirtää ajoneuvon (${data.aVehicle.registerNumber ?? '-'}, ${data.aVehicle.VIN ?? '-'}) käyttäjälle ${data.aUser.name}?`
          )
        ) {
          updateVehicle({
            variables: {
              id,
              userId: data.aUser.id,
            },
          });
        }
      }
    },
    context,
  });

  const handleSubmit = (body: TransferConsumerFormBody) => {
    confirmTransfer({
      variables: {
        id,
        userId: body.userId,
      },
    });
  };

  return (
    <AppFormScene
      type="create"
      title={t('title')}
      form={transferConsumerForm}
      isSubmitLoading={loading}
      onSubmit={handleSubmit}
      backLink={routesConfig.VEHICLE.EDIT.replace(':id', id)}
    />
  );
};
